export type Year = {
  m1: number,
  m2: number,
  m3: number,
  m4: number,
  m5: number,
  m6: number,
  m7: number,
  m8: number,
  m9: number,
  m10: number,
  m11: number,
  m12: number,
  year: number
}

const getEmptyYears = (numberOfYears: number, beginYear: number): Year[] => {
  const emptyYear: Year = {
    m1: 0,
    m2: 0,
    m3: 0,
    m4: 0,
    m5: 0,
    m6: 0,
    m7: 0,
    m8: 0,
    m9: 0,
    m10: 0,
    m11: 0,
    m12: 0,
    year: 0
  }
  const items: Year[] = []
  if(numberOfYears === 1 && beginYear === 0) {
    let newObj: Year = Object.assign({}, emptyYear);
    newObj.year = 1;
    items.push(newObj);
  } else {
    for(let i = 0; i < numberOfYears; i++) {
      let newObj: Year = Object.assign({}, emptyYear);
      newObj.year = i + beginYear + 1;
      items.push(newObj);
    }
  }
  return items;
}

export default getEmptyYears
